import { pages } from '../util/global-methods';

const routes = [
  // {path: 'terms', component: pages('terms'), props: true},
  // {path: 'terms/:group', component: pages('terms'), props: true},
  // {path: 'terms/privacy-policy', component: pages('terms/privacy'), props: true},
  // {path: 'terms/buyer-terms-policy', component: pages('terms/buyer'), props: true},
  // {path: 'terms/seller-terms-policy', component: pages('terms/seller'), props: true},
  // {path: 'terms/finance-terms-policy', component: pages('terms/finance'), props: true},
  // {path: 'terms/location-terms-policy', component: pages('terms/location'), props: true},
  // {path: 'terms/third-party-privacy-policy', component: pages('terms/third-party'), props: true},
  // {path: 'terms/cancellation-refund-policy', component: pages('terms/cancellation-refund'), props: true},
  // {path: 'terms/marketing', component: pages('terms/marketing'), props: true}
];

export default routes;
